import React from 'react';
import { useNavigate } from 'react-router-dom';
import SideHustleLayout from '../../components/SideHustleLayout';

const SideHustleHome: React.FC = () => {
  const navigate = useNavigate();

  const components = [
    {
      id: 'talents',
      title: 'Talents & Passions',
      path: '/side-hustle/talents',
    },
    {
      id: 'problems',
      title: 'Problem Identifier',
      path: '/side-hustle/problems',
    },
    {
      id: 'canvas',
      title: 'Business Model Canvas',
      path: '/side-hustle/canvas',
    },
    {
      id: 'budgeting',
      title: 'Business Budgeting',
      path: '/side-hustle/budgeting',
    },
    {
      id: 'leap',
      title: 'Taking the Leap',
      path: '/side-hustle/leap',
    },
    {
      id: 'dreams',
      title: 'The Dream Station',
      path: '/side-hustle/dreams',
    },
  ];

  return (
    <SideHustleLayout>
      <div className="flex flex-col items-center justify-center p-6 min-h-[calc(100vh-80px)]">
        <div className="max-w-5xl w-full">
          <h1 className="text-5xl font-bold text-center mb-16">Components</h1>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {components.map((component) => (
              <button
                key={component.id}
                onClick={() => navigate(component.path)}
                className="bg-primary hover:bg-primary/90 text-white text-center py-8 px-6 rounded-3xl shadow-lg transition-all transform hover:scale-105 text-2xl font-semibold"
              >
                {component.title}
              </button>
            ))}
          </div>
        </div>
      </div>
    </SideHustleLayout>
  );
};

export default SideHustleHome;
